import { render, staticRenderFns } from "./CommonSpaces.vue?vue&type=template&id=05db8371"
import script from "./CommonSpaces.vue?vue&type=script&lang=ts"
export * from "./CommonSpaces.vue?vue&type=script&lang=ts"
import style0 from "./CommonSpaces.vue?vue&type=style&index=0&id=05db8371&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports